var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F2FAF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.46 31.4898V28.5698C18.46 27.5998 19.22 26.7298 20.3 26.7298C21.27 26.7298 22.14 27.4898 22.14 28.5698V31.3798C22.14 33.3298 20.52 34.9498 18.57 34.9498C16.62 34.9498 15 33.3198 15 31.3798V25.2198C14.89 19.5998 19.33 15.0498 24.95 15.0498C30.57 15.0498 35 19.5998 35 25.1098V31.2698C35 33.2198 33.38 34.8398 31.43 34.8398C29.48 34.8398 27.86 33.2198 27.86 31.2698V28.4598C27.86 27.4898 28.62 26.6198 29.7 26.6198C30.67 26.6198 31.54 27.3798 31.54 28.4598V31.4898",
    stroke: "#009A56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.961f26ecfdbbdc75035e1811d6f02e5b.svg";
export { ForwardRef as ReactComponent };